import { render, staticRenderFns } from "./navigation.vue?vue&type=template&id=81cafb5a&scoped=true"
import script from "./navigation.vue?vue&type=script&lang=js"
export * from "./navigation.vue?vue&type=script&lang=js"
import style0 from "./navigation.vue?vue&type=style&index=0&id=81cafb5a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81cafb5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81cafb5a')) {
      api.createRecord('81cafb5a', component.options)
    } else {
      api.reload('81cafb5a', component.options)
    }
    module.hot.accept("./navigation.vue?vue&type=template&id=81cafb5a&scoped=true", function () {
      api.rerender('81cafb5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/frontPageManage/configureManage/mobilePreview/components/navigation.vue"
export default component.exports